import React from 'react'
import { APIS } from '../../../config/apis'
import { RedirectExternalUrl } from '@laramie/ui';
export default function PublicRoute(props) {
  return (
    (!props.isAuthenticated)
      ? ( props.component )
      : ( <RedirectExternalUrl location={ APIS.URLS.AUTH_REDIRECT } /> )
  )
}
